<template>
  <div data-app class="navigate-container">
    <div>
      <h4>
        {{ title.replace(/\"/g, "") }}
      </h4>
    </div>
    <div>
      <el-button class="mt-12 submit-button" type="primary" @click="goHome()">{{
        $t("wap.text26")
      }}</el-button>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.title = this.$router?.history?.current?.query?.title || "";
  },
  data() {
    return {
      title: ""
    };
  },
  watch: {},
  methods: {
    goHome() {
      window.location.href = "/";
    }
  }
};
</script>
<style scoped>
.navigate-container {
  background-image: url("~@/assets/img/navigate/simple.jpg");
  background-size: cover;
  background-position: left;
  background-repeat: no-repeat;

  width: 100vw;
  height: 100vh !important;
  overflow: hidden;
  max-width: 100vw;
  display: flex;
  align-items: center;
  height: 100%;
  justify-content: center;
  flex-direction: column;
}
</style>
